import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import { FaHandshake } from "react-icons/fa";
import "swiper/css";
import "swiper/css/free-mode";
import "../Vender/css/HotelSlider.css";
import { getAllPrefferPartner } from "../api/ourPrefferPartner.api";

const HotelSlider = () => {
  const [prefferPartners, setPrefferPartners] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const sliderRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getAllPrefferPartner();
        console.log("Hotel Partners API Response:", data);
        setPrefferPartners(data || []);
      } catch (err) {
        console.error("Error fetching partners:", err);
        // Set mock data immediately
        setPrefferPartners([
          {
            _id: "1",
            partner_name: "Marriott Hotels",
            image:
              "https://via.placeholder.com/150x80/0066cc/ffffff?text=Marriott",
          },
          {
            _id: "2",
            partner_name: "Hilton Hotels",
            image:
              "https://via.placeholder.com/150x80/ff6600/ffffff?text=Hilton",
          },
          {
            _id: "3",
            partner_name: "Hyatt Hotels",
            image:
              "https://via.placeholder.com/150x80/cc0066/ffffff?text=Hyatt",
          },
          {
            _id: "4",
            partner_name: "Radisson Hotels",
            image:
              "https://via.placeholder.com/150x80/009900/ffffff?text=Radisson",
          },
          {
            _id: "5",
            partner_name: "ITC Hotels",
            image: "https://via.placeholder.com/150x80/990099/ffffff?text=ITC",
          },
        ]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 },
    );

    if (sliderRef.current) {
      observer.observe(sliderRef.current);
    }

    return () => {
      if (sliderRef.current) {	
        observer.unobserve(sliderRef.current);
      }
    };
  }, []);

  // Duplicate partners for seamless loop
  const duplicatedPartners =
    prefferPartners.length > 0
      ? [...prefferPartners, ...prefferPartners, ...prefferPartners]
      : [];

  return (
    <section
      className={`partner-marquee ${isVisible ? "visible" : ""}`}
      ref={sliderRef}
      style={{ minHeight: "200px" }} // Ensure section has height
    >
      <div className="marquee-container">
        {/* Header */}
        <div className="marquee-header">
          {/* <span className="marquee-tag">
            <FaHandshake />
            <span>Trusted Partners</span>
          </span> */}
          <h2 className="marquee-title">We Work With The Best</h2>
        </div>

        {/* Marquee Slider */}
        <div className="marquee-track">
          <Swiper
            modules={[Autoplay, FreeMode]}
            spaceBetween={40}
            slidesPerView="auto"
            freeMode={true}
            loop={duplicatedPartners.length > 5}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            speed={4000}
            className="marquee-swiper"
            onSwiper={(swiper) => swiper.autoplay?.start()}
          >
            {duplicatedPartners.length > 0 ? (
              duplicatedPartners.map((partner, index) => (
                <SwiperSlide key={index} style={{ width: "auto" }}>
                  <div className="marquee-item">
                    <img
                      src={partner.image || "/assets/images/placeholder.jpg"}
                      alt={partner.partner_name || "Partner"}
                    />
                  </div>
                </SwiperSlide>
              ))
            ) : (
              <SwiperSlide>
                <p className="no-data">No partners available</p>
              </SwiperSlide>
            )}
          </Swiper>

          {/* Fade Edges */}
          <div className="marquee-fade fade-left"></div>
          <div className="marquee-fade fade-right"></div>
        </div>

        {/* Bottom Text */}
        {/* <p className="marquee-footer">
          Partnering with <strong>{prefferPartners.length || 0}+</strong>{" "}
          premium brands worldwide
        </p> */}
      </div>
    </section>
  );
};

export default HotelSlider;
